module.exports = __webpack_public_path__ + "static/vista-5-656724545fb3c61a8c3aca72ed846149.jpeg";